import { SearchScope } from './types';
import {
    SCOPE_ALL_OBJECT,
    SCOPE_CATALOGUE_OBJECT,
    SCOPE_EAUDIOBOOK_OBJECT,
    SCOPE_EBOOK_OBJECT,
    SCOPE_EPRESS_OBJECT,
    SCOPE_LANGUAGELEARNING_OBJECT,
    SCOPE_LOTE_OBJECT
} from './constants';
import { useMatch } from 'react-router-dom';

export function useDeriveSearchScopeFromPathname(): SearchScope {
    const catalogueMatch = useMatch('/catalogue/:loanFormat?/*');
    const libxMatchLegacy = useMatch('/libxchange/*');
    const libxMatch = useMatch('/shop/:shopLanguage/libxchange/*');
    const loteMatch = useMatch('/language/lote/*');
    const selectionListMatch = useMatch('/orderlists/:id/*');
    const languageLearningMatchLegacy = useMatch('/language/languagelearning/*');
    const languageLearningMatch = useMatch('/shop/:shopLanguage/languagelearning/*');
    const languageBundlesMatch = useMatch('/language/bundles/*');
    const collectionMatch = useMatch('/collection/:section/:loanFormat?/*');
    const collectionMgmtMatch = useMatch('/collectionmgmt/:section/:loanFormat?/*');
    const merchandisingMatch = useMatch('/merchandising/:section/:loanFormat?/*');
    const localContentMatch = useMatch('/localcontent/*');
    const campaignsMatch = useMatch('/marketing/campaigns/:loanFormat?/*');
    const marketingMatch = useMatch('/marketing/*');
    const shopUnlimitedMatch = useMatch('/shop/:shopLanguage/unlimited/campaigns/:loanFormat/*');
    const shopLoanFormatMatch = useMatch('/shop/:shopLanguage/:loanFormat/*');

    if (catalogueMatch) {
        const loanFormat = catalogueMatch.params.loanFormat?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    if (libxMatchLegacy || libxMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    if (loteMatch) {
        return SCOPE_LOTE_OBJECT;
    }

    if (selectionListMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    if (languageLearningMatchLegacy || languageLearningMatch) {
        return SCOPE_LANGUAGELEARNING_OBJECT;
    }

    if (languageBundlesMatch) {
        return SCOPE_CATALOGUE_OBJECT;
    }

    if (collectionMatch || collectionMgmtMatch || merchandisingMatch) {
        const loanFormat = collectionMatch
            ? collectionMatch.params['loanFormat']?.toLowerCase()
            : collectionMgmtMatch?.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    if (localContentMatch) {
        const loanFormat = localContentMatch.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    if (campaignsMatch) {
        const loanFormat = campaignsMatch.params['loanFormat']?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_ALL_OBJECT;
        }
    }

    if (marketingMatch) {
        return SCOPE_ALL_OBJECT;
    }

    if (shopUnlimitedMatch) {
        const loanFormat = shopUnlimitedMatch.params.loanFormat?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    if (shopLoanFormatMatch) {
        const loanFormat = shopLoanFormatMatch.params.loanFormat?.toLowerCase();
        switch (loanFormat) {
            case 'ebooks':
                return SCOPE_EBOOK_OBJECT;
            case 'eaudiobooks':
                return SCOPE_EAUDIOBOOK_OBJECT;
            case 'emagazines':
            case 'epress':
                return SCOPE_EPRESS_OBJECT;
            default:
                return SCOPE_CATALOGUE_OBJECT;
        }
    }

    return SCOPE_CATALOGUE_OBJECT;
}
